// extracted by mini-css-extract-plugin
export var actionIcon = "_u1-0";